import React, { useEffect, useState, useRef } from "react";
import {Icon} from '@iconify/react';
import '../../src/assets/Styles/PredictiveNegotiationStatusCardCSS/PredictiveNegotiatinStatusCardCSS.css';

const PredictiveNegotiationStatusCard = ({ items = [], headerTitle, headerMsg, onAction }) => {
  const [blinkingStatuses, setBlinkingStatuses] = useState({});
  const [counters, setCounters] = useState({});
  const intervalsRef = useRef({});

  const hasForceTime = items.some(item => item.status === "Routed (Out of Window)");
  
  useEffect(() => {
    const newBlinkingStatuses = {};
    items.forEach(item => {
      if (item.status && item.status !== "Pending") {
        newBlinkingStatuses[item.confirmationNumber] = true;
        setTimeout(() => {
          setBlinkingStatuses(prev => ({ ...prev, [item.confirmationNumber]: false }));
        }, 5000);
      }
    });
    setBlinkingStatuses(newBlinkingStatuses);
  }, [items])


  useEffect(() => {
    items.forEach(item => {
      const { confirmationNumber, status } = item;
  
      if (status === "Pending") {
        // if (!intervalsRef.current[confirmationNumber]) {
        //   setCounters(prev => ({
        //     ...prev,
        //     [confirmationNumber]: prev[confirmationNumber] ?? 90
        //   }));
  
        //   intervalsRef.current[confirmationNumber] = setInterval(() => {
        //     setCounters(prev => ({
        //       ...prev,
        //       [confirmationNumber]: (prev[confirmationNumber] ?? 0) + 1
        //     }));
        //   }, 1000);
        // }
        if (!intervalsRef.current[confirmationNumber]) {
          setCounters(prev => ({
            ...prev,
            [confirmationNumber]: prev[confirmationNumber] ?? 120
          }));

          intervalsRef.current[confirmationNumber] = setInterval(() => {
            setCounters(prev => {
              const currentValue = prev[confirmationNumber] ?? 0;

              if (currentValue <= 1) {
                // Stop and clean up when reaching 0
                clearInterval(intervalsRef.current[confirmationNumber]);
                delete intervalsRef.current[confirmationNumber];

                return {
                  ...prev,
                  [confirmationNumber]: 0,
                };
              }

              return {
                ...prev,
                [confirmationNumber]: currentValue - 1,
              };
            });
          }, 1000);
        }
      } else {
        if (intervalsRef.current[confirmationNumber]) {
          clearInterval(intervalsRef.current[confirmationNumber]);
          delete intervalsRef.current[confirmationNumber];
          setCounters(prev => ({
            ...prev,
            [confirmationNumber]: 0
          }));
        }
      }
    });
  
    return () => {
      // Clean up intervals on unmount
      //Object.values(intervalsRef.current).forEach(clearInterval);
    };
  }, [items]);


  const renderButtons = (item) => {
    const { status, confirmationNumber, pickDate, showLoader, counter } = item;
    switch (status) {
      case "Routed (Out of Window)":
        return (
          <>
            <span title={"Force Request Time"}><Icon icon="entypo:back-in-time"
              style={{width:"22px", height:"22px", color:"#2b8917", cursor:"pointer"}}
              onClick={() => onAction("Force Time", status, confirmationNumber, pickDate)} />
            </span>
            <span title={"Cancel Trip"}><Icon icon="game-icons:cancel"
              style={{width:"22px", height:"22px", color:"#d24e4e", cursor:"pointer"}}
              onClick={() => onAction("Cancel", status, confirmationNumber, pickDate)} />
            </span>

          </>


        );
      case "Routed":
        return (
          <>
            <span title={"Cancel Trip"}><Icon icon="game-icons:cancel"
              style={{width:"22px", height:"22px", color:"#d24e4e", cursor:"pointer"}}
              onClick={() => onAction("Cancel", status, confirmationNumber, pickDate)} />
            </span>
          </>
        );
      case "UnRouted":
        return (
          <>
            <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" style={{width:"22px", height:"22px", color:"black", cursor:"pointer"}}
                onClick={() => onAction("Edit", status, confirmationNumber, pickDate)} /></span>
            <span title={"Cancel Trip"}><Icon icon="game-icons:cancel"
              style={{width:"22px", height:"22px", color:"#d24e4e", cursor:"pointer"}}
              onClick={() => onAction("Cancel", status, confirmationNumber, pickDate)} />
            </span>
          </>
        );
      case "Cancelled":
        return (
          <>
          </>
        );
      case "Pending":
        return (
          <>
           {/* {showLoader && <span className="loaderPredictive"></span>} */}
           {/* {showLoader && (   
             <div className="circle-counter">{counters[confirmationNumber] ?? 0}</div>)
          }  */}
           {showLoader && counters[confirmationNumber] > 0 ? (
            <div className="circle-counter">
                {counters[confirmationNumber]}
              </div>
            )
            :
              (
                <>
                <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" style={{width:"22px", height:"22px", color:"black", cursor:"pointer"}}
                    onClick={() => onAction("Edit", status, confirmationNumber, pickDate)} /></span>
                <span title={"Cancel Trip"}><Icon icon="game-icons:cancel"
                  style={{width:"22px", height:"22px", color:"#d24e4e", cursor:"pointer"}}
                  onClick={() => onAction("Cancel", status, confirmationNumber, pickDate)} />
                </span>
              </>
              )
          }
          </>
        );
      
      default:
        return (
          <>
       
          {/* {
            showLoader && (   
             <div className="circle-counter">{counters[confirmationNumber] ?? 0}</div>)
          }  */}
            {showLoader && counters[confirmationNumber] > 0 ? (
              <div className="circle-counter">
                  {counters[confirmationNumber]}
                </div>
              ) :
              (
                <>
                <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" style={{width:"22px", height:"22px", color:"black", cursor:"pointer"}}
                    onClick={() => onAction("Edit", status, confirmationNumber, pickDate)} /></span>
                <span title={"Cancel Trip"}><Icon icon="game-icons:cancel"
                  style={{width:"22px", height:"22px", color:"#d24e4e", cursor:"pointer"}}
                  onClick={() => onAction("Cancel", status, confirmationNumber, pickDate)} />
                </span>
              </>
              )
            }
          </>
        );
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Routed":
        return "#a8ffb4";
      case "Routed (Out of Window)":
        return "#cfeab3";
      case "UnRouted":
        return "#f8ae94";
      case "Pending":
        return "antiquewhite";
      case "Cancelled":
        return "red";
      default:
        return "gray"; // fallback
    }
  };

  return (

  <div>
    <div>
      <h6 style={{background: "#eaedea", padding: "5px"}}>{headerTitle}</h6>
      <p>{headerMsg}</p>
    </div>
      <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "Roboto" }}>
        <thead style={{background: "#e3e5e6"}}>
          <tr>
            {/* <th style={{ border: "1px solid #ccc", width: "22%", textAlign: "center" }}>Msg</th> */}
            <th style={{ border: "1px solid #ccc", width: "3%", textAlign: "center" }}>Conf#</th>
            <th style={{ border: "1px solid #ccc", width: hasForceTime ? "24%" : "5%", textAlign: "center" }}>Status</th>
            <th style={{ border: "1px solid #ccc", width: "12%", textAlign: "center" }}>Req. Time</th>
            <th style={{ border: "1px solid #ccc", width: "15%", textAlign: "center" }}>Offered Time</th>
            <th style={{ border: "1px solid #ccc",  width: hasForceTime ? "7%" : "4%", textAlign: "center" }}></th>
          </tr>
        </thead>
        <tbody>
          {
          [...items]
          .sort((a, b) => {
            const dateA = a.pickDate ? new Date(a.pickDate) : new Date(0);
            const dateB = b.pickDate ? new Date(b.pickDate) : new Date(0);
            return dateA - dateB; // Descending order (latest first)
          }).map(item => (
            <tr key={item.confirmationNumber} style={{ borderBottom: "1px solid #ddd" }}>
              {/* <td style={{ border: "1px solid #ccc", padding: "8px", fontSize: "small" }}>{item.title}</td> */}
              <td style={{ border: "1px solid #ccc", padding: "8px", fontSize: "medium", textAlign: "center", fontWeight: "bold" }}>{item.confirmationNumber}</td>
              <td style={{ border: "1px solid #ccc", padding: "8px", fontSize: "medium", textAlign: "center" }}>
                <span
                  className={blinkingStatuses[item.confirmationNumber] ? "blink-status" : ""}
                  style={{
                    fontWeight: "bold",
                    background: getStatusColor(item.status),
                    fontStyle: "italic",
                    padding: "5px 10px",
                    fontSize: "16px",
                    borderRadius: "4px",
                    color: getStatusColor(item.status) == "red" ? 'white' : 'black'
                  }}
                >
                  {item.status}
                </span>
              </td>
              <td style={{ border: "1px solid #ccc", padding: "8px", background: "aliceblue", fontSize: "15px", textAlign: "center" }}>{item.pickDate || "-"}</td>
              <td style={{ border: "1px solid #ccc", padding: "8px", background: getStatusColor(item.status) == "red" ? 'white' :"#e6f2e6"  , fontSize: "15px", textAlign: "center",}}>{item.offeredTime || "-"}</td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                <div style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center" }}>
                  {renderButtons(item)}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: "10px", textAlign: "right" }}>
        <button
          onClick={() => onAction("Continue", null, null)}
          style={{ width: "20%", background: "#07447b", color: "white" }}
        >
      Continue
    </button>
  </div>
  </div>
  );
};

export default PredictiveNegotiationStatusCard;
